import { qsa } from "../inc/dom.js";

const initFaqs = () => {
    const items = qsa("[data-faq-item]");
    if (!items.length) return;

    const setOpen = (item, open) => {
        const trigger = item.querySelector("[data-faq-trigger]");
        item.classList.toggle("is-open", open);
        if (trigger) trigger.setAttribute("aria-expanded", String(open));
    };

    items.forEach((item) => {
        const trigger = item.querySelector("[data-faq-trigger]");
        if (!trigger) return;
        trigger.addEventListener("click", () => {
            const open = !item.classList.contains("is-open");
            const list = item.closest(".faq-list");
            if (open && list) {
                qsa("[data-faq-item]", list).forEach((sibling) => {
                    if (sibling !== item) setOpen(sibling, false);
                });
            }
            setOpen(item, open);
        });
    });

    const openFromHash = () => {
        const id = window.location.hash.slice(1);
        if (!id) return;
        const panel = document.getElementById(id);
        const item = panel && panel.closest("[data-faq-item]");
        if (item) setOpen(item, true);
    };

    window.addEventListener("hashchange", openFromHash);
    openFromHash();
};

initFaqs();
